import { useState, useEffect } from 'react'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import gearsOfWarLogoWhite from '../assets/images/logos/gearsOfWar-white.svg'
import gearsOfWarLogoBlack from '../assets/images/logos/gearsOfWar.svg'

import gearsOfWarLogoFullWhite from '../assets/images/logos/gearsOfWar-full-white.svg'
import gearsOfWarLogoFullBlack from '../assets/images/logos/gearsOfWar-full.svg'

import gearsOfWarLogoNoOmenWhite from '../assets/images/logos/gearsOfWar-vertical-no-omen-white.svg'
import gearsOfWarLogoNoOmenBlack from '../assets/images/logos/gearsOfWar-vertical-no-omen-black.svg'

import theCoalitionLogoFullWhite from '../assets/images/logos/theCoalition-full-white.svg'
import theCoalitionLogoFullBlack from '../assets/images/logos/theCoalition-full.svg'

import xboxLiveWhite from '../assets/images/logos/xboxLive-white.svg'
import xboxLiveBlack from '../assets/images/logos/xboxLive.svg'

/**
 * Logo Names:
 *
 * Gears of War: gearsOfWar / gearsOfWarFull (with omen)
 * The Coalition Studio: theCoalition
 *
 * Theme: light/dark
 */

const LOGOS = {
    gearsOfWar: { logoWhite: gearsOfWarLogoWhite, logoBlack: gearsOfWarLogoBlack },
    gearsOfWarFull: { logoWhite: gearsOfWarLogoFullWhite, logoBlack: gearsOfWarLogoFullBlack },
    gearsOfWarNoOmen: { logoWhite: gearsOfWarLogoNoOmenWhite, logoBlack: gearsOfWarLogoNoOmenBlack },
    theCoalition: {
        logoWhite: 'https://cdn.gearsofwar.com/gearsofwar/sites/2/2024/10/theCoalition-white-5f2b1be4bddeb-6705aa9b6d1ed.svg',
        logoBlack: 'https://cdn.gearsofwar.com/gearsofwar/sites/2/2024/10/theCoalition-5f2b1be957e4c-6705aa98714dc.svg'
    },
    theCoalitionFull: { logoWhite: theCoalitionLogoFullWhite, logoBlack: theCoalitionLogoFullBlack },
    xboxGameStudios: {
        logoWhite: 'https://cdn.gearsofwar.com/gearsofwar/sites/2/2024/10/XboxGameStudios_2020_hrz_Wht-5f2b1addc7aa9-6705aa94c2dff.svg',
        logoBlack: 'https://cdn.gearsofwar.com/gearsofwar/sites/2/2024/10/XboxGameStudios_2020_hrz_Grn-5f2b1ad431c06-6705aa9e3c657.svg'
    },
    xboxLive: { logoWhite: xboxLiveWhite, logoBlack: xboxLiveBlack }
}

const DEFAULT_OPTIONS = {
    enableContrast: true,
    theme: null
}

const useLogo = (name = 'webstarter', options = DEFAULT_OPTIONS) => {
    const currentTheme = useTheme()
    const _options = { ...DEFAULT_OPTIONS, ...options }
    const _theme = _options.theme || currentTheme.palette.type
    const defaultLogo = _theme === 'light' ? LOGOS[name].logoBlack : LOGOS[name].logoWhite
    const [logo, setLogo] = useState(defaultLogo)
    const isHighContrast = useMediaQuery(currentTheme.accessibility.highContrast.mediaQuery('active'))
    const isHighContrastWB = useMediaQuery(currentTheme.accessibility.highContrast.prefersDark)
    const isHighContrastBW = useMediaQuery(currentTheme.accessibility.highContrast.prefersLight)

    useEffect(() => {
        if (_theme === 'light') {
            if ((isHighContrastWB || isHighContrast) && !isHighContrastBW && _options.enableContrast) {
                setLogo(LOGOS[name].logoWhite)
            } else {
                setLogo(LOGOS[name].logoBlack)
            }
        } else {
            if (isHighContrastBW && _options.enableContrast) {
                setLogo(LOGOS[name].logoBlack)
            } else {
                setLogo(LOGOS[name].logoWhite)
            }
        }
    }, [isHighContrastBW, isHighContrastWB, isHighContrast, _options.enableContrast, name, _theme])

    return logo
}

export default useLogo
